import React from 'react';
import {
  Outlet,
} from 'react-router-dom';
import ViewProvider from 'pages/Dashboard/contexts/viewContext';
import useEMRAccess from 'views/EMR/hooks/useEMRAccess';

export default function Charts() {
  const { defaultChartTab } = useEMRAccess();

  return (
    <ViewProvider initialTab={defaultChartTab}>
      <Outlet />
    </ViewProvider>
  );
}
